import { apiGet } from "./api";

export type UserSearchItem = {
  id: string;
  username: string;
  avatarUrlSmall?: string | null;
  avatarUrl?: string | null;
  bio?: string | null;
};

/**
 * GLOBAL kullanıcı araması (takip sınırlaması yok).
 * Header’daki InlineUserSearch bu fonksiyonu kullanmaya devam eder.
 */
export async function searchUsers(q: string, limit = 10) {
  const s = q.trim();
  if (!s) return [] as UserSearchItem[];

  const capped = Math.max(1, Math.min(25, limit));
  const params = new URLSearchParams();
  params.set("q", s);
  params.set("limit", String(capped));

  const r = await apiGet<{ ok: true; items: UserSearchItem[] }>(
    `/api/users/search?${params.toString()}`
  );
  return r.items;
}

/**
 * Mention kullanımına özel arama.
 * Varsayılan: sadece takip edilenlerden getir (followingOnly = true).
 * Gerektiğinde global fallback için calling tarafta 2. istek yapılabilir.
 */
export async function searchUsersForMention(
  q: string,
  opts?: { limit?: number; followingOnly?: boolean }
) {
  const s = q.trim();
  if (!s) return [] as UserSearchItem[];
  const limit = Math.max(1, Math.min(25, opts?.limit ?? 8));
  const followingOnly = opts?.followingOnly ?? true;

  const params = new URLSearchParams();
  params.set("q", s);
  params.set("limit", String(limit));
  if (followingOnly) params.set("following", "1");

  const r = await apiGet<{ ok: true; items: UserSearchItem[] }>(
    `/api/users/search?${params.toString()}`
  );
  return r.items;
}
